import React from 'react';
import AuthWrapper from 'components/AuthWrapper';
import AuthTop from 'components/AuthTop';
import FormErrors from '../FormErrors';
import './NotificationWindow.css';
import CloseIcon from 'components/CloseIcon/icon-close.svg';

function NotificationWindow({ message, close }) {
  return (
    <div className="notification-window">
      <AuthWrapper>
        <AuthTop hideLogo>
          {close && (
            <img
              className="modal-close-icon"
              onClick={close}
              src={CloseIcon}
              alt="Close Icon"
            />
          )}
          <FormErrors errors={[message]} />
        </AuthTop>
      </AuthWrapper>
    </div>
  );
}

export default NotificationWindow;



// WEBPACK FOOTER //
// ./src/components/NotificationWindow/index.js